






import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations } from '@/ts/store/Constants';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import DateMethods from '@/mixins/DateMethods.vue';
import moment from 'moment';

@Component({
    computed: {
        ...mapGetters({
            facility: 'SharedFacilities/getActiveAdminFacility',
        }),
    },
    components: {
        FullCalendar,
    },
})
export default class SharedFacilityDayCalendar extends Mixins(DateMethods) {
    public events: any = [];
    public calendar: any = null;

    constructor() {
        super();
    }

    get day() {
        return this.$store.getters['SharedFacilities/getAdminCalendarSelectedDate'];
    }

    get dateBookings() {
        return this.$store.getters['SharedFacilities/getActiveFacilitySelectedDateBookings'];
    }

    @Watch('day')
    public dayChanged() {
        this.calendar.getApi().gotoDate(this.day);
        this.seedEvents();
    }

    @Watch('dateBookings')
    public dateBookingsChanged() {
        this.seedEvents();
    }

    get calendarOptions() {
        return {
            plugins: [ dayGridPlugin, interactionPlugin, timeGridPlugin ],
            initialView: 'timeGridDay',
            headerToolbar: {
                start: '',
                center: '',
                end: '' ,
            },
            allDaySlot: false,
            height: '600px',
            initialDate: this.day,
            slotDuration: '00:60:00',
            slotLabelFormat: {
                hour: 'numeric',
                minute: '2-digit',
                omitZeroMinute: true,
                meridiem: 'short',
            },
            events: this.events,
            eventDidMount: this.handleEventsMount,
        };
    }

    public seedEvents() {
        const bookings = this.dateBookings;
        this.events = [];
        for (const booking of bookings) {
            this.events.push({
                className: 'facility-event',
                start: booking.startTime,
                end: this.getBookingEndDate(booking.startTime, booking.endTime),
                extendedProps: { booking },
            });
        }
        this.calendar.getApi().addEventSource(this.events);
    }

    public getBookingEndDate(start: any, end: any) {
        if (start === end) {
            return end;
        } else {
            return moment(end).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
        }
    }

    public handleEventsMount(info: any) {
        const booking = info.event.extendedProps.booking;
        const self = this;
        tippy(info.el, {
            content: `<div class="event-tooltip">
                <p class="event-tooltip__header">${booking.facilityName}</p>
                <p class="event-tooltip__text event-tooltip__time">${this.handleFormatedDate(booking.startTime, 'MMM, Do dddd - HH:mm')} - ${this.handleFormatedDate(booking.endTime, 'HH:mm')}</p>
                <p class="mb-0 event-tooltip__text">${booking.user.person ? booking.user.person.first_name + ' ' + booking.user.person.family_name : booking.user.name}</p>
                <p class="mb-0 event-tooltip__text">${booking.user.address ? booking.user.address.street : ''}</p>
                <p class="mb-0 event-tooltip__text">${booking.user.person ? booking.user.person.phone_number : ''}</p>
                <button id="cancelReservation" class="btn btn-light-danger fz-14 mt-3">${ this.$t('shared-facilities.cancel-reservation', 'Cancel reservation') }</button>
            </div>`,
            allowHTML: true,
            arrow: false,
            placement: 'left',
            trigger: 'click',
            theme: 'light',
            onShown() {
                document.getElementById('cancelReservation').addEventListener('click', () => {
                    self.cancelReservation(booking);
                });
            },
            onDestroy(instance) {
                document.getElementById('cancelReservation').removeEventListener('click', () => {
                    self.cancelReservation(booking);
                });
            },
        });
    }

    public cancelReservation(booking: any) {
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'SharedFacilities/CANCEL_RESERVATION',
            confirmActionData: { bookingId: booking.id },
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-cancel-this-reservation', 'Are you sure you want to cancel this reservation?'),
            confirmInfoText: booking.name,
            confirmButton: this.$t('general.remove', 'Remove'),
            confirmIconVisibility: true,
            confirmIcon: 'fa-clock',
            confirmHeaderText: this.$t('forms.cancel-the-reservation', 'Cancel the reservation'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public mounted() {
        this.calendar = (this.$refs.dayCalendar as HTMLElement);
        this.seedEvents();
    }
}
